import React from 'react'

// third party components

// images and icons
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import EditIcon from 'assets/icons/edit-icon-22x22.svg?component'
import MerchAddIcon from 'assets/icons/merch-add-item.svg?component'

// styles
import styles from './index.module.scss'

interface MerchMenuPageProps {
  isOwn: boolean
  setOpenShareModal: any
  editStoreSettings: any
  addMerchItem: any
}

const MerchMenuPage = ({ isOwn, setOpenShareModal, editStoreSettings, addMerchItem }: MerchMenuPageProps) => {
  return (
    <div className={styles.menuArea}>
      <div
        className={`${styles.menuItem}`}
        onClick={() => {
          setOpenShareModal(true)
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Store</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
      </div>

      {isOwn && (
        <div>
          <div className={styles.separator} />
          <div
            className={`${styles.menuItem}`}
            onClick={() => {
              editStoreSettings()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>
                <EditIcon alt="" />
              </div>
              <div>
                <div className={styles.itemTitle}>Store Settings</div>
                <div className={styles.itemDescription}>Edit name, description, or social preview</div>
              </div>
            </div>
          </div>
          <div className={styles.separator} />

          <div
            className={`${styles.menuLastItem}`}
            onClick={() => {
              addMerchItem()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>
                <MerchAddIcon alt="" />
              </div>
              <div>
                <div className={styles.itemTitle}>Add Item</div>
                <div className={styles.itemDescription}>Publish an item to your store</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MerchMenuPage
